import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Users from "./Pages/Users/Users";
import BranchAdmins from "./Pages/Users/BranchAdmins/BranchAdmins";
import Nurses from "./Pages/Users/Nurses/Nurses";
import Departments from "./Pages/Department/Departments";
import AddDepartmentPopUp from "./Pages/Department/AddDepartmentPopup";
import Doctors from "./Pages/Doctors/Doctors";
import Hospitals from "./Pages/Hospitals/Hospitals";
import BranchManagement from "./Pages/BranchManagement/BranchManagement";
import Login from "./Pages/Login/login";
import ForgotPassword from "./Pages/ForgotPassword/ForgotPassword";
import ResetPassword from "./Pages/ResetPassword/ResetPassword";
import PrivateRoute from "./utils/PrivateRoute";
import BookingPage from "./Pages/BookingsHistory/BookingsPage";
import DoctorSchedulePage from "./Pages/DoctorSchedule/DoctorSchedulePage";
import DoctorSlotsPage from "./Pages/Slots/DcotorSlotsPage";
import BookSlotPage from "./Pages/BookSlot/BookSlotPage";
import AppointmentReport from "./Pages/Reports/AppointmentReports/AppointmentReports";
import BookingReports from "./Pages/Reports/BookingReportsRefactored";
import NurseDashboard from "./Pages/NurseDashboard/NurseDashboard";
import NurseAssignments from "./Pages/NurseAssignments/NurseAssignments";
import Unauthorized from "./Pages/Unauthorized";
import NotFound from "./Pages/NotFound";

const appRouter = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/forgot-password", element: <ForgotPassword /> },
  { path: "/reset-password", element: <ResetPassword /> },
  { path: "/unauthorized", element: <Unauthorized /> },

  // Admin Routes
  {
    path: "/dashboard",
    element: <PrivateRoute allowedRoles={["branch_admin", "hospital_admin"]} />,
    children: [
      { path: "", element: <Dashboard /> },
      { path: "users", element: <Users /> },
      { path: "users/branch-admins", element: <BranchAdmins /> },
      { path: "users/nurses", element: <Nurses /> },
      { path: "nurse-assignments", element: <NurseAssignments /> },
      { path: "department", element: <Departments /> },
      { path: "add-department", element: <AddDepartmentPopUp /> },
      { path: "doctors", element: <Doctors /> },
      { path: "branches", element: <BranchManagement /> },
      { path: "hospitals", element: <Hospitals /> },
      { path: "bookings", element: <BookingPage /> },
      { path: "doctors/:doctorId/schedule", element: <DoctorSchedulePage /> },
      {
        path: "doctor/:doctorId/schedules/:date/slots",
        element: <DoctorSlotsPage />,
      },
      { path: "book-slot", element: <BookSlotPage /> },
      { path: "doctorslots", element: <DoctorSlotsPage /> },
      { path: "reports/appointments", element: <AppointmentReport /> },
      { path: "reports/bookings", element: <BookingReports /> },
    ],
  },

  // Nurse Routes
  {
    path: "/nurse-dashboard",
    element: <PrivateRoute allowedRoles={["nurse"]} />,
    children: [{ path: "", element: <NurseDashboard /> }],
  },

  // Catch-all route - show 404 page
  {
    path: "*",
    element: <NotFound />,
  },
]);

const Body = () => {
  return <RouterProvider router={appRouter} />;
};

export default Body;
